module.exports = __webpack_public_path__ + "static/img/bg_mo.9b89fad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/promotion/PR010231/bg_mo.png
// module id = OV6d
// module chunks = 10